module.exports = __webpack_public_path__ + "static/media/faqBalance-es-hi.742c5258.vtt";